import Model from "./abstract/Model";

export const MarkerColorKey = {
  RED: 'red'
}

export default class MarkerColor extends Model {

  constructor(props) {
    super();

    this.initializeAttributes(props, {});
  }
}
